import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';
import config from '../../config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';
import { useNavigate } from 'react-router-dom';

function List() {
    const profileFilter = chooseProfileFilter();
    const navigate = useNavigate();

    const pathFrontEnd = '/gci/projects/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/projects/delete`,
        endpoint: `${endpointBackend}gci/projects/getall`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'gci_company_id',
                type: 'select',
                label: 'Empresa',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllCompanies,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 4
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Projetos',
        labelTitleButtonAdd: 'Incluir novo projeto',
        fieldsShowOnDelete: ['project_name'],
        formFilters: !profileFilter.gci_company_id ? filters : null,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'company',
                label: 'Empresa',
            },
            {
                name: 'project_type',
                label: 'Tipo de Projeto',
            },
            {
                name: 'project_name',
                label: 'Nome do Projeto',
            }
        ],
        columnsButtons: [
            {
                buttons: [
                    {
                        label: 'Mapa de Vendas',
                        name: 'sales_map',
                        icon: 'fas fa-map-marked-alt',
                        className: 'btn btn-success btn-sm btn-action',
                        width: '140px',
                        onClick: (item) => navigate(`/gci/projects/sales-map/${item.id}`),
                        disabledButtonRule: (item) => item.organization_type !== 'default'
                    }
                ]
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
